export const NoteNodeType = {
    Text: 'text',
    Title: 'title',
    Disposition: 'disposition',
    DispositionIcons: 'disposition-icons',
    General: 'general',
};
//# sourceMappingURL=types.js.map